import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=64c63c3e&"
import script from "./Sticky.js?vue&type=script&lang=js&"
export * from "./Sticky.js?vue&type=script&lang=js&"
import style0 from "./Sticky.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports